import { runInAction } from 'mobx';
import { QueueStore } from '../store/queue-store';
import { RawQueueRowData } from '../store/types-2';

export function handleStoreUpdates<T extends RawQueueRowData>(
    store: QueueStore<T>,
    idsInRequest: number[],
    viewsInResponse: T[] | undefined
): void {
    if (!viewsInResponse) {
        return;
    }
    const idsInResponse = viewsInResponse.map((view) => view.id);
    const idsInRequestNotInResponse = idsInRequest.filter((id) => !idsInResponse.includes(id));
    runInAction(() => {
        store.removeRows(idsInRequestNotInResponse);
        store.upsertRows(viewsInResponse);
    });
}
